import React from 'react';
import { Box } from '@mantine/core';
import { sanitizeProductDescriptionForDisplay } from '@/utils/productDescriptionHtml';
import classes from './ProductDescriptionHtml.module.css';

export interface ProductDescriptionHtmlProps {
  html: string;
}

/** Renders sanitized product description HTML from the server. */
export function ProductDescriptionHtml({ html }: ProductDescriptionHtmlProps) {
  const safe = sanitizeProductDescriptionForDisplay(html);
  return (
    <Box
      className={classes.html}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}
